import React from 'react';

// icons
import CloudCircle from '@mui/icons-material/CloudCircle';

import styled from 'styled-components';

// theme
import theme from '../../constants/aampeTheme';

interface NestedErrorProps {
    errorMsg?: string;
    small?: boolean;
    style?: React.CSSProperties;
}

const NestedError: React.FC<React.PropsWithChildren<NestedErrorProps>> = ({
    errorMsg,
    small,
    style,
}) => {
    return (
        <Container style={{ ...style }}>
            <CloudCircle
                style={{ fontSize: small ? '50px' : '100px' }}
                color="secondary"
            />
            <div
                style={{
                    fontSize: small ? '15px' : '20px',
                    marginLeft: theme.spacing4(2),
                }}
            >
                {errorMsg && typeof errorMsg === 'string' ? (
                    <p>{errorMsg}</p>
                ) : (
                    <p>We're having some connection issues.</p>
                )}
            </div>
        </Container>
    );
};

export default NestedError;

const Container = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    width: '100%',
    minHeight: '100%',
});
